<template>
  <m-feature-enable-switch feature="usageReporting" />
</template>

<script lang="ts">
import Vue from 'vue';
import MFeatureEnableSwitch from '@/components/Settings/MSettingsFeatures/MFeatureEnableSwitch';

export default Vue.extend({
  name: 'm-settings-features-usage-reporting',
  components: { MFeatureEnableSwitch },
});
</script>
